import SEO from '../components/SEO'
import AnnouncementBar from '../components/AnnouncementBar'
import Navbar from '../components/Navbar'
import Hero from '../sections/Hero'
import TrialSignup from '../sections/TrialSignup'
import LogosStrip from '../sections/LogosStrip'
import SiteBuilder from '../sections/SiteBuilder'
import OrderTypes from '../sections/OrderTypes'
import Tables from '../sections/Tables'
import Menu from '../sections/Menu'
import Dispatch from '../sections/Dispatch'
import PaymentsAndPerks from '../sections/PaymentsAndPerks'
import Team from '../sections/Team'
import Testimonials from '../sections/Testimonials'
import Pricing from '../sections/Pricing'
import FAQ from '../sections/FAQ'
import FinalCTA from '../sections/FinalCTA'
import Footer from '../sections/Footer'

export default function HomePage() {
  return (
    <div className="min-h-screen text-black" style={{ background: '#FAFAF8' }}>
      <SEO path="/" />
      <AnnouncementBar />
      <Navbar />
      <Hero />
      <LogosStrip />
      <SiteBuilder />
      <OrderTypes />
      <Tables />
      <Menu />
      <Dispatch />
      <PaymentsAndPerks />
      <Team />
      <Testimonials />
      <Pricing />
      <TrialSignup />
      <FAQ />
      <FinalCTA />
      <Footer />
    </div>
  )
}
